import React from 'react';
import styles from './Checkbox.module.scss';
import classNames from 'classnames';

interface CheckboxProps {
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  label: string;
  name: string;
  propRef?: any;
  checked?: boolean;
  'data-testid'?: string;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  onChange,
  label,
  name,
  propRef,
  checked,
  'data-testid': dataTestId,
  className,
}) => {
  return (
    <label className={classNames(styles.label, className)} htmlFor={name}>
      <input
        type="checkbox"
        className={styles.checkbox}
        onChange={onChange}
        data-testid={dataTestId}
        name={name}
        ref={propRef}
        {...(checked !== undefined ? { checked } : {})}
      />
      <span className={styles.customCheckbox}></span>
      {label}
    </label>
  );
};

export default Checkbox;
